
import * as requestPromise from 'request-promise'
import { appConfig } from '../firebase/config';
import { IUser, IUserCreate } from '../types/blueprint';


const HOST = process.env.HOST || appConfig.zimicoreConfig.baseUrl;
// const PORT = process.env.PORT || 80;
const BASEURL = 'https://' + HOST  //+ (PORT !== '80' ? ':' + PORT : '');
const BLUEPRINT_APIPATH = '/blueprint/api/v1/';
const FCM_SUBS_PATH = '/api/fcm/tokenToTopic';

export const getDevices = (jwt: string, orgId?: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        requestPromise.get({
            headers: { 'Authorization': 'bearer ' + jwt },
            url: BASEURL + BLUEPRINT_APIPATH + 'devices' + (orgId ? '?organizationId=' + orgId : ''),
            resolveWithFullResponse: true,
        })
            .then((ret: any) => {
                const body = JSON.parse(ret.body);
                resolve(body);
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};

export const getOrganizations = (jwt: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        requestPromise.get({
            headers: { 'Authorization': 'bearer ' + jwt },
            url: BASEURL + BLUEPRINT_APIPATH + 'organizations',
            resolveWithFullResponse: true,
        })
            .then((ret: any) => {
                const body = JSON.parse(ret.body);
                resolve(body);
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};

export const getOrganization = (jwt: string, orgId: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        requestPromise.get({
            headers: { 'Authorization': 'bearer ' + jwt },
            url: BASEURL + BLUEPRINT_APIPATH + 'organizations/' + orgId,
            resolveWithFullResponse: true,
        })
            .then((ret: any) => {
                const body = JSON.parse(ret.body);
                resolve(body);
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};

export const fcmSubscribeToTopic = (jwt: string, token: string, topic: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        requestPromise.post({
            headers: { 'Authorization': 'bearer ' + jwt, 'content-type': 'application/json' },
            url: BASEURL + FCM_SUBS_PATH,
            resolveWithFullResponse: true,
            body: JSON.stringify({
                registrationToken: token,
                topic
            })
        })
            .then((ret: any) => {
                const body = JSON.parse(ret.body);
                resolve(body);
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};

export const fcmUnSubscribeToTopic = (jwt: string, token: string, topic: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        requestPromise.delete({
            headers: { 'Authorization': 'bearer ' + jwt, 'content-type': 'application/json' },
            url: BASEURL + FCM_SUBS_PATH,
            resolveWithFullResponse: true,
            body: JSON.stringify({
                registrationToken: token,
                topic
            })
        })
            .then((ret: any) => {
                const body = JSON.parse(ret.body);
                resolve(body);
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};

export const sendPasswordReset = (email: string): Promise<any> => {
    return new Promise<any>((resolve, reject) => {
        requestPromise.post({
            headers: { 'content-type': 'application/json' },
            url: BASEURL + '/user/password_reset',
            resolveWithFullResponse: true,
            body: JSON.stringify({
                email
            })
        })
            .then((ret: any) => {
                const body = JSON.parse(ret.body);
                resolve(body);
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};

export const sendPasswordResetSuccess = (email: string): Promise<any> => {
    return new Promise<void>((resolve, reject) => {
        requestPromise.post({
            headers: { 'content-type': 'application/json' },
            url: BASEURL + '/user/password_reset_success',
            resolveWithFullResponse: false,
            body: JSON.stringify({
                email
            })
        })
            .then((ret: any) => {
                // const body = JSON.parse(ret.body);
                resolve();
            })
            .catch((err: any) => {
                reject(err);
            });
    });
};

export const createUserDetails = (jwt: string, user: IUserCreate): Promise<IUser> => {
    return new Promise((resolve, reject) => {
        requestPromise.post({
            headers: {
                'content-type': 'application/json', 'Authorization': 'Bearer ' + jwt
            },
            url: BASEURL + '/blueprint/api/v1/users',
            resolveWithFullResponse: true,
            body: JSON.stringify(user.data)
        })
            .then(userRet => {
                resolve(userRet);
            })
            .catch(err => {
                reject(err);
            })

    })
}